import styled from "styled-components";

export const ArticleTitle = styled.div`
    grid-area: title;
    position: relative;
    margin-top: 10px;
`;

export const TitleBackplate = styled.div`
    background: url(${(props: { imagePath?: string }) =>
        props.imagePath || "/articles/title-backplate.png"});
    background-blend-mode: darken;
    width: 100%;
    height: 100%;
    background-size: cover;
    border-radius: 40px;
    border: 0;
    background-repeat: no-repeat;
    position: absolute;
    z-index: 0;
    @media (max-width: 1240px) {
        background-position: 80% center;
    }
`;

export const TitleText = styled.div`
    margin: 65px 30px;
    display: grid;
    grid-auto-flow: row;
    max-width: 60%;
    grid-gap: 35px;
    @media (max-width: 1240px) {
        margin: 32px 20px 20px 18px;
        font-size: 18px;
        line-height: 140%;
        max-width: 100%;
        grid-gap: 20px;
    }
`;

export const TitleTextLarge = styled.div`
    margin: 65px 30px;
    display: grid;
    grid-auto-flow: row;
    grid-gap: 35px;
    @media (max-width: 1240px) {
        margin: 32px 20px 20px 18px;
        font-size: 18px;
        line-height: 140%;
        max-width: 100%;
        grid-gap: 20px;
    }
`;

export const TitleHead = styled.div`
    font-size: 72px;
    line-height: 70px;
    font-weight: 700;
    color: ${(props: { color?: string }) => props.color || "white"};
    z-index: 1;
    @media (max-width: 1240px) {
        font-weight: 700;
        font-size: 36px;
        line-height: 40px;
    }
`;

export const TitleContent = styled.div`
    font-size: 18px;
    z-index: 1;
    line-height: 140%;
    color: #ffffff;
`;
